import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./authContext";

export default function AdminRoute({ children }) {
  const location = useLocation();
  const { isAuthenticated, isLoading, user } = useAuth();
  const isStaffUser = user?.role === "admin" || user?.role === "moderator";

  if (isLoading) {
    return (
      <div className="account-shell">
        <div className="account-loading">Checking admin access...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  if (!isStaffUser) {
    return <Navigate to="/" replace />;
  }

  return children;
}